// Default to production URL if WORKER_URL is not set
const API_BASE_URL = self.WORKER_URL || 'https://hotsidex-api.pascal-ledesma.workers.dev';

// Helper function to handle API responses
const handleResponse = async (response) => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'API request failed');
    }
    return data;
  }
  throw new Error('Invalid response format');
};

// Helper function to make API requests with proper error handling
const apiRequest = async (endpoint, options = {}) => {
  try {
    const url = `${API_BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`;
    console.log('Making API request to:', url);
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
    return await handleResponse(response);
  } catch (error) {
    console.error(`API Error (${endpoint}):`, error);
    // Return mock data on error
    return getMockData(endpoint);
  }
};

const getMockData = (endpoint) => {
  const mockListings = [
    {
      id: 1,
      name: 'Expert Kitchen Repairs',
      city: 'New York',
      rating: 4.8,
      reviewCount: 156,
      services: ['Commercial Ovens', 'Refrigeration', '24/7 Emergency'],
      response_time: 'Under 2 hours',
      distance: '2.5 miles',
      availability: '24/7',
    },
    {
      id: 2,
      name: 'Pro Restaurant Equipment',
      city: 'Los Angeles',
      rating: 4.7,
      reviewCount: 123,
      services: ['Kitchen Equipment', 'HVAC', 'Preventive Maintenance'],
      response_time: 'Same day service',
      distance: '3.8 miles',
      availability: 'Mon-Sat',
    },
  ];

  const mockImage = {
    url: 'https://images.unsplash.com/photo-1557955776-857434f1c721',
    credit: {
      name: 'Unsplash',
      link: 'https://unsplash.com',
    },
  };

  // Remove /api/ prefix for matching
  const cleanEndpoint = endpoint.replace('/api/', '');

  if (cleanEndpoint.includes('listings/featured')) {
    return mockListings;
  }
  if (cleanEndpoint.includes('listings/search')) {
    return mockListings;
  }
  if (cleanEndpoint.includes('listings/city/')) {
    return mockListings;
  }
  if (cleanEndpoint.includes('listings/')) {
    return mockListings[0];
  }
  if (cleanEndpoint.includes('images/')) {
    return mockImage;
  }

  return null;
};

export const searchListings = (query) => apiRequest(`/api/listings/search?q=${encodeURIComponent(query)}`);

export const api = {
  getFeaturedListings: () => apiRequest('/api/listings/featured'),
  getCityListings: (city) => apiRequest(`/api/listings/city/${encodeURIComponent(city)}`),
  getListingDetails: (id) => apiRequest(`/api/listings/${id}`),
  getCityImage: (city) => apiRequest(`/api/images/city/${encodeURIComponent(city)}`),
  getKitchenImage: () => apiRequest('/api/images/kitchen'),
};

// Error handling wrapper
const withErrorHandling = async (apiCall) => {
  try {
    return await apiCall();
  } catch (error) {
    console.error('API Error:', error);
    // Return mock data on error
    if (typeof apiCall === 'function') {
      const mockResult = getMockData(apiCall.toString());
      if (mockResult) return mockResult;
    }
    throw error;
  }
};

export { withErrorHandling };
